// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import addStoreDetails from '@tcp/core/src/queries/addStoredetails.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler';
import { setApplePaymentInProgress } from '../../../components/features/CnC/Checkout/container/Checkout.action';
import { graphQlErrorHandler } from '../../../utils/errorMessage.util';

export const getModifiedPayload = (payload) => {
  return {
    firstName: payload.firstName,
    lastName: payload.lastName,
    phone: payload.phone,
    email: payload.email,
    c_altName: payload.c_altName,
    c_altEmail: payload.c_altEmail,
  };
};

export const addEditStoreDetailsApi = (payload, errorsMapping = {}) => {
  const queryPayload = {
    basketId: payload?.basketId,
    pickUpDetailsDto: {
      c_altEmail: payload?.c_altEmail,
      c_altName: payload?.c_altName,
      email: payload?.email,
      firstName: payload?.firstName,
      lastName: payload?.lastName,
      phone: payload?.phone,
      c_vibesSmsPhoneNo: payload?.c_vibesSmsPhoneNo,
      c_phoneCountryCode: payload?.phoneCountryCode,
    },
  };

  const graphQLQuery = {
    query: addStoreDetails,
    variables: queryPayload,
    type: 'mutation',
  };
  return executeStatefulGraphQLQuery(graphQLQuery)
    .then((res) => {
      if (res.errors) {
        const err = res.errors;
        throw graphQlErrorHandler(err, errorsMapping);
      }
      const storeDetails = res.data?.addStoreDetails;
      return {
        storeDetails,
      };
    })
    .catch((err) => {
      setApplePaymentInProgress(false);
      logger.error({
        error: `Exception in setAddEditStoreDetailsApi API Call: ${JSON.stringify(err)}`,
        payload,
      });
      throw graphQlErrorHandler(err, errorsMapping);
    });
};
